import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Divider from "@mui/material/Divider";

export default function ProfileCard() {
  const { t } = useTranslation();

  const socialLinks = [
    {
      href: "https://github.com/matsukitakeshi",
      img: `${process.env.PUBLIC_URL}/github.webp`,
      alt: "GitHub",
    },
    {
      href: "https://www.linkedin.com/in/takeshi-matsuki/",
      img: `${process.env.PUBLIC_URL}/linkedin.webp`,
      alt: "LinkedIn",
    },
    {
      href: "https://x.com/takeshi_matsuki",
      img: `${process.env.PUBLIC_URL}/x.webp`,
      alt: "X",
    },
    {
      href: "https://www.facebook.com/profile.php?id=100011542213360",
      img: `${process.env.PUBLIC_URL}/facebook.webp`,
      alt: "Facebook",
    },
  ];

  return (
    <Card
      sx={{
        maxWidth: 720,
        margin: "0 auto",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        overflow: "hidden",
        border: "1px solid #E2E8F0",
      }}
    >
      {/* Photo */}
      <Box
        sx={{
          width: { xs: "100%", sm: 220 },
          aspectRatio: { xs: "4/3", sm: "unset" },
          minHeight: { sm: 180 },
          flexShrink: 0,
          alignSelf: "stretch",
          backgroundImage: `url(${process.env.PUBLIC_URL}/matsuki.webp)`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      />

      {/* Content */}
      <CardContent
        sx={{
          flex: 1,
          p: { xs: 3, md: 4 },
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Box>
          <Typography
            variant="h5"
            component="div"
            sx={{ fontWeight: 700, color: "#0F172A", mb: 0.25 }}
          >
            Matsuki Takeshi
          </Typography>
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: 500, color: "#64748B", fontSize: "1rem", mb: 1 }}
          >
            松木 健
          </Typography>
          <Typography
            variant="body2"
            sx={{
              display: "inline-block",
              backgroundColor: "#EFF6FF",
              color: "#3B82F6",
              px: 1.5,
              py: 0.5,
              borderRadius: 1,
              fontWeight: 600,
              fontSize: "0.78rem",
              letterSpacing: "0.03em",
            }}
          >
            {t("home.position")}
          </Typography>
        </Box>

        <Divider sx={{ my: 1, borderColor: "#F1F5F9" }} />

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: 1.8, fontSize: "0.88rem" }}
        >
          {t("home.profile")}
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mt: "auto",
            pt: 2,
          }}
        >
          {socialLinks.map((link) => (
            <a
              key={link.alt}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                component="img"
                src={link.img}
                alt={link.alt}
                sx={{
                  width: 22,
                  height: 22,
                  objectFit: "contain",
                  opacity: 0.7,
                  transition: "opacity 0.15s ease, transform 0.15s ease",
                  "&:hover": { opacity: 1, transform: "translateY(-1px)" },
                }}
              />
            </a>
          ))}
          <Link to="/biography" style={{ marginLeft: "auto" }}>
            <Button
              variant="outlined"
              size="small"
              sx={{
                borderColor: "#CBD5E1",
                color: "#475569",
                fontWeight: 500,
                fontSize: "0.8rem",
                px: 2,
                "&:hover": {
                  borderColor: "#3B82F6",
                  color: "#3B82F6",
                  backgroundColor: "#EFF6FF",
                },
              }}
            >
              Biography →
            </Button>
          </Link>
        </Box>
      </CardContent>
    </Card>
  );
}
